import axios from 'axios';
import { NEWS_API_URL } from 'lib/api';
import { getHeaders } from './headers';

export const getAllPosts = async (data) => {
  try {
    const res = await axios.post(`${NEWS_API_URL}/post/getPosts`, data, getHeaders());
    if (res.data.name === 'AxiosError') return null;

    return res.data;
  } catch (e) {
    return e;
  }
};

export const getPostById = async (id) => {
  try {
    const res = await axios.get(`${NEWS_API_URL}/post/getPost/${id}`, getHeaders());
    if (res.data.name === 'AxiosError') return null;

    return res.data;
  } catch (e) {
    return e;
  }
};

export const createPost = (data) => {
  try {
    const res = axios.post(`${NEWS_API_URL}/post/createPost`, data, getHeaders());
    return res;
  } catch (e) {
    return e;
  }
};

export const updatePost = async (data) => {
  try {
    const res = await axios.patch(`${NEWS_API_URL}/post/updatePost`, data, getHeaders());
    if (res.data.name === 'AxiosError') return null;

    return res.data;
  } catch (e) {
    return e;
  }
};

export const deletePost = async (id) => {
  try {
    const res = await axios.patch(`${NEWS_API_URL}/post/deletePost/${id}`, null, getHeaders());
    if (res.data.name === 'AxiosError') return null;

    return res.data;
  } catch (e) {
    return e;
  }
};
